import * as React from 'react'

function SvgThreeDotsLogo(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 18 18"
      fill="currentColor"
      {...props}
    >
      <circle cx="9" cy="9" r="9" fill="#F0FFF9" />
      <g clip-path="url(#clip0_10510_125612)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.2 10.7501C12.2976 10.7501 11.5667 10.0191 11.5667 9.11673C11.5667 8.2149 12.2976 7.4834 13.2 7.4834C14.1018 7.4834 14.8333 8.2149 14.8333 9.11673C14.8333 10.0191 14.1018 10.7501 13.2 10.7501Z"
          fill="#00D37E"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.00003 10.7501C8.09762 10.7501 7.3667 10.0191 7.3667 9.11673C7.3667 8.2149 8.09762 7.4834 9.00003 7.4834C9.90245 7.4834 10.6334 8.2149 10.6334 9.11673C10.6334 10.0191 9.90245 10.7501 9.00003 10.7501Z"
          fill="#00D37E"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.79984 10.7501C3.898 10.7501 3.1665 10.0191 3.1665 9.11673C3.1665 8.2149 3.898 7.4834 4.79984 7.4834C5.70225 7.4834 6.43317 8.2149 6.43317 9.11673C6.43317 10.0191 5.70225 10.7501 4.79984 10.7501Z"
          fill="#00D37E"
        />
      </g>
      <defs>
        <clipPath id="clip0_10510_125612">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(2 2)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default SvgThreeDotsLogo
